import { Box } from '@chakra-ui/react';

export const FilterColumn = ({ children }: any) => {
  return <Box className="flex flex-col gap-2 w-1/3">{children}</Box>;
};
